module.exports = __webpack_public_path__ + "components/forecast-table/static/freezing-graph_backdrop-snow-2a4f38e6425fad4fc75f8741c79a61c7.png";